import React from 'react';
import './LastSec.css';
import VR from '../components/common/VR';

const LastSec = () => {
  return (
    <section className='last-section-container-big'>
    <section className="last-section-container">
      <div className="cta-left-content">
        <h2 className="cta-title">Start Your Real Estate Journey Today</h2>
        <p className="cta-description">
          Your dream property is just a click away. Whether you're looking for a new home, 
          a strategic investment, or expert real estate advice, Estatein is here to assist you every step of the way.
        </p>
        <button className="cta-button">
          Explore Properties
        </button>
      </div>

      <div className="cta-right-content">
        <VR />
      </div>
    </section>
    </section>
  );
};

export default LastSec;